import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import serviceReducer from '../features/services/serviceSlice';
import contentReducer from '../features/content/contentSlice';
import blogReducer from '../features/blog/blogSlice'; // Bu satırın var olduğundan emin olun
import adminInfoReducer from '../features/adminInfo/adminInfoSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    service: serviceReducer,
    content: contentReducer,
    blog: blogReducer, // Ve reducer'ın burada eklendiğinden emin olun
    adminInfo: adminInfoReducer,
  },
});